import useTotp from "../../Service/hooks/useTOTP"



export default function ClickOnLinkInEmail({  }) {

    const { confirmChallenge } = useTotp();


    return <div>
        <h1>De code is correct!</h1>
        <p>
            We hebben uw telefoon kunnen registeren. U ontvangt binnen enkele minuten ter bevestiging een e-mail met daarin een link. Klikt u op die link om het proces af te ronden.
        </p>
        <div className="flex flex-row gap-3 w-full">
            <button className="flex-1 px-3 py-2 bg-green-500 text-white" onClick={() => confirmChallenge()}>Vernieuwen</button>
        </div>
    </div>
}
